import React, { Component } from "react";
import { CreateTaxonomyAccordionContentComponent } from "./createTaxonomyAccordionContent";
import { html } from "lit";
import { OmniTableComponent, OmniTileComponent, OmniToolbarComponent, OmniTooltipNextComponent, OmniIconComponent, OmniIconMenu, OmniDropdownComponent, LoaderComponent, AlertMessagesService, Utils, CookieService, MediaOpsService, trackEvent, creativeMap } from "../../../shared";
import { CreateTaxonomyService } from "../";
import { CreateCreativeService } from "../../creatives";
import { PlacementDetailsTableService, PlacementUtils } from "../../placements";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import { CreativeAgGridComponent } from '../../creatives';
import { firstPage } from "omni-ui/icon/iconset-interactive.js";

export class CreateTaxonomyComponent extends Component {
  campaignId;
  placementId;
  placementSyntheticId;
  checkedTaxonomy = [];
  selectedPopupValue = "";
  bulkCopyCount = "";
  openPopupElm = "";

  constructor(props) {
    super(props);
    this.state = {
      disableBulkCopy: true,
      isPopupOpen: false,
      createTaxonomys: [{ id: 0, taxonomyTableData: [] }],
      allTaxonomyData: props.allTaxonomyData,
      spinnerCount: 1,
      taxonomyIds: {},
      createType: "Taxonomy",
      creativeTableCheckAll: false
    };
    //decode Param value to remove special chreacter
    this.campaignId = decodeURIComponent(this.props?.params?.campaignId);
    this.placementId = decodeURIComponent(this.props?.params?.placementId);
    this.placementSyntheticId = decodeURIComponent(this.props?.params?.placementSyntheticId);
    props.setSpinnerCount(0);

    /* The below code is checking if the `placementName` property is falsy. If it is falsy, it checks if
      the `campaignId` property exists in `params`. If it exists, it calls the `getPlacements` function
      from `MediaOpsService` with the `campaignId` as an argument. It then retrieves the `placements`
      data from the result and filters it to find the placement with an `id` that matches `placementId`.
      It sets the `placementName` property to the `placement_taxonomy` of the found placement. If there
      is an error during the  */
    if (!this.props?.placementName && !this.props.isCreative) {
      (!this.props?.openCreateTaxonomyPage && this.campaignId) && this.getPlacements(this.props);
    }
  }
  
  /**
   * Fetches placements based on campaign ID from props and sets the selected placement name.
   * On success, filters the placements to find the one matching the placement ID from props,
   * then sets the placement name using setPlacementName. On failure, displays an alert message
   * with a retry option. Always decrements the spinner count in the finally block.
   * sending 'versionOneApi' in 'getplacement' call, to find which version  of PDMS we are using,then use api as per version
   * 
   * @param {Object} props - The properties passed to the component, expected to contain:
   * @param {Object} props.params - Parameters containing campaignId and placementId.
   * @param {Function} props.setPlacementName - Function to set the placement name in the parent component.
   */
  getPlacements = (props) => {
    //this.campaignId have decodeURIComponent value from params
    let campaignId = encodeURIComponent(this.campaignId);
    MediaOpsService.getPlacements(campaignId,null,this.props?.versionOneApi)
    .then(
      (result) => {
        const placements = result?.data;
        const placement = placements.filter(
          (item) =>
            item?.id?.toString() === this.placementId?.toString()
        )[0];
        this.props.setPlacementName(placement?.placement_taxonomy);
      },
      (error) => {
        AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: () => this.getPlacements(props), title: 'Placement API cannot be loaded', bodyMsgArr: []}]);
      }
    )
    .finally(() => 
    this.setState({spinnerCount: 0})
    );
  };

  /**
   * Retrieves all taxonomy schemas and sets the state with the data.
   * @returns {void}
   */
  getAllTaxonomySchemas = () => {
    CreateTaxonomyService.getAllTaxonomyDataForDropdown().then((response) => {
      const allTaxonomyObj = {};
      response?.forEach((element, index) => {
        allTaxonomyObj[element?.name] = element;
        if (index === response.length - 1) {
          this.setState({ allTaxonomyData: allTaxonomyObj }, () => this.createTaxonomyOptions());
        }
      })
    })
      .catch((error) => {AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: this.getAllTaxonomySchemas, title: 'Taxonomy API cannot be loaded', bodyMsgArr: []}]);})
      .finally(() => {
        this.setState({ spinnerCount: 0 });
      });
  }

  /**
   * Lifecycle method that is called after the component is mounted.
   * If the component is in creative mode, it sets the campaign name and create type.
   * Then it calls the createTaxonomyOptions method to initialize taxonomy options.
   * @returns {void}
  */ 
  componentDidMount = () => {

    if (!this.props?.location?.state?.campaignObj?.campaign_name) {
      this.loadCampaignData();
    }

    if(this.props.isCreative && this.props.state?.campaignObj?.campaignName){
      this.props.setCampaignName(Utils.formatCampaignTitle(this.props.state?.campaignObj));
      this.setState({createType: "Creative"});
    }
    this.createTaxonomyOptions();
  };

  /**
   * Loads campaign data by campaign ID and initializes the component state.
   * 
   * This method is called when campaign object data is not available in props.location.state.
   * It fetches campaign details using the campaign ID from URL parameters, updates the 
   * component's location state with the fetched data, sets the campaign name in the parent
   * component, and then proceeds to load placement data.
   * 
   */
  loadCampaignData = () => {
    this.props.setSpinnerCount(1);
    const { campaignId } = this.props.params;
    MediaOpsService.getCampaignDataById(campaignId, '', this.props?.versionOneApi)
      .then((response) => {
        let campaignObj = response[0];
        this.props.location.state = { campaignObj};
        this.props.setCampaignName(Utils.formatCampaignTitle(campaignObj));
        this.loadPlacementsData();
      })
      .catch((error) => {
        AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: () => this.loadCampaignData(), title: 'Campaign API cannot be loaded', bodyMsgArr: [] }]);
      })
  };

  /**
   * Loads placement data for the current campaign and updates the component state.
   * 
   * This method is called after successfully loading campaign data. It fetches placement
   * information associated with the campaign and merges it with the existing campaign object
   * in the component's location state. The method handles loading indicators and error states.
   * 
   */
  loadPlacementsData = () => {
    this.props.setSpinnerCount(1);
    const { campaignId } = this.props.params;
    PlacementDetailsTableService.getPlacementsWithDelivered(campaignId, { is_delete: false }, this.props.versionOneApi)
      .then((response) => {
        const campaignObj = JSON.parse(JSON.stringify(this.props.location.state.campaignObj));
        campaignObj.placementData = response.data;
        this.props.location.state = { campaignObj: campaignObj };
      }).catch((error) => {
        AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: () => this.loadPlacementsData(), title: 'Placements API cannot be loaded', bodyMsgArr: [] }]);
      }).finally(() => {
        this.props.setSpinnerCount(0);
      });
  }

  /* the below function is called when there is a change in props & it will create the taxonomy options of each field of each taxonomy type
    and store it in the `taxonomyIds` object */
  createTaxonomyOptions = () => {
    const taxonomyIds = {};
    Object.keys(this.state.allTaxonomyData).forEach((taxonomyType, index) => {
      let data = this.state.allTaxonomyData[taxonomyType];
      if (data) {
        taxonomyIds[data.id] = { type: taxonomyType, schemaFields: data.fields };
        data?.fields?.length && data?.fields?.forEach((field, i) => {
          let name = field.name;
          let optionsArr = [];
          if (field.fielditems.length) {
            field.fielditems.forEach(item => {
              optionsArr.push({
                id: item.code,
                value: item.name,
              });
            });
          }
          taxonomyIds[data.id][name] = {
            field_type: field.field_type,
            options: optionsArr,
          };
        });
      }

    });

    this.setState({ taxonomyIds }, () => { 
      if(this.props.isCreative){
        this.getAllCreatives('',true);
      } else {
        this.getAllTaxonomies() 
      }
    });
  };

  /** The below function is to be called on the component load and after each operation to get all the latest taxonomies list
   * @function getAllTaxonomies
   * @param {string} successMsg - success message to be displayed on success of the API call
   * @returns {void}
   */
  getAllTaxonomies = (successMsg) => {
    let taxonomyMap = {};
    this.setState({spinnerCount: 1});
    CreateTaxonomyService.getTaxonomy(this.placementSyntheticId)
      .then((response) => {
        for (let i = 0; i < response.data.length; i++) {
            let taxonomyObj = {
              _id: response.data[i].id,
              taxonomyValueId: response.data[i].taxonomy_value_id,
              taxonomyName: response.data[i].taxonomy_name,
              taxonomyValue: response.data[i].taxonomy_value,
              taxonomySchema: response.data[i].taxonomy_schema,
              taxonomyId: response.data[i].taxonomy_schema_id,
              taxonomyTypeId: response.data[i].taxonomy_type_id,
              taxonomyFields: [],
              syncStatus: response.data[i]?.status || "Not Synced",
              checked: false,
            };
            if (!taxonomyMap[response.data[i].taxonomy_schema_id]) {
              taxonomyMap[response.data[i].taxonomy_schema_id] = [];
              taxonomyMap[response.data[i].taxonomy_schema_id].push(taxonomyObj)
            } else {
              taxonomyMap[response.data[i].taxonomy_schema_id].push(taxonomyObj);
            }
        }
        this.createTableStructure(taxonomyMap);
        if (successMsg) {
          AlertMessagesService.showSuccessToastMessage(successMsg);
        }
      })
      .catch((err) => {
        AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Refresh', retryBtnEvent: () => this.getAllTaxonomies(successMsg), title: 'Taxonomy API cannot be loaded', bodyMsgArr: []}]);
        this.setState({spinnerCount: 0});
      })
  };
  
  /**
   * Creates a table structure for the taxonomies.
   * @function createTableStructure
   * @param {object} taxonomyMap - The map of taxonomies.
   * @returns {void}
   * This function iterates through the taxonomyMap and creates a list of taxonomies with unique keys and element IDs.
   * It also sets the state with the created taxonomy list and calls afterTableOperations.
   * If the created taxonomy list is empty, it adds a default object to the list.
  */ 
  createTableStructure = (taxonomyMap) => {
    let createdTaxonomyList = [];
    let currentElement = 0;
    for (const key in taxonomyMap) {
      if (taxonomyMap.hasOwnProperty(key)) {
        for (let j = 0; j < taxonomyMap[key].length; j++) {
          taxonomyMap[key][j]._uniqueKey = j;
          taxonomyMap[key][j].elementId = currentElement;
        }
        let taxonomyListObj = {
          id: currentElement,
          taxonomy_id: key,
          taxonomyTableData: taxonomyMap[key],
        };
        createdTaxonomyList.push(taxonomyListObj);
      }
      currentElement++;
    }
    // Sort the createdTaxonomyList based on taxonomy_id
    if (createdTaxonomyList.length) {
      // Sort the createdTaxonomyList based on taxonomy_id to retain table position
      createdTaxonomyList.sort((a, b) => {
        if (a.taxonomy_id < b.taxonomy_id) return -1;
        if (a.taxonomy_id > b.taxonomy_id) return 1;
        return 0;
      });
      // Sort the data based on created_at , newly created will come at last
      for(let i=0;i<createdTaxonomyList.length;i++) {
        createdTaxonomyList[i].taxonomyTableData.sort((a, b) => {
          if (a.created_at < b.created_at) return -1;
          if (a.created_at > b.created_at) return 1;
          return 0;
        });
      }
    } else {
      createdTaxonomyList.push({
        id: 0,
        taxonomyTableData: [],
      });
    }
    this.setState({ createTaxonomys: createdTaxonomyList, spinnerCount: 0 }, () => {
      setTimeout(() => {
        this.afterTableOperations();
      });
    });
  }

  /**
   * The below function is to be called after the table is created and it will add the event listener for file upload
   * and set the unique id for each table
   * @function afterTableOperations
   * @returns {void}
  */ 
  afterTableOperations = () => {
    // function added to handle the case when wrap text is more than two lines, then increase the width of the column by 50px in recursive manner
    let adjustWidth = (table) => {
      let taxonomyNameColumn = table?.shadowRoot?.querySelectorAll('.taxonomyNameCol');
      for(let i=0;i<taxonomyNameColumn?.length;i++){
        if(taxonomyNameColumn[i].scrollHeight > taxonomyNameColumn[i].clientHeight){
          taxonomyNameColumn[i].style.width = parseInt(taxonomyNameColumn[i].style.width, 10) + 50 + 'px';
          i--;
        }
      }
      // set row background to highlight the newly created/updated row after login
      let tableData = table.data;
      for(let i=0;i<tableData.length;i++){
        if(tableData[i].highlight){
          let tableRowId = tableData[i]._uniqueKey;
          let rowEl = table?.shadowRoot?.querySelector(`tr[id="${tableRowId}"]`);
          rowEl.style.cssText = 'background-color: #F9ECD2 !important';
        }
      }
    }
    
    // Adding event listener for file upload & setting unique id for each table
    let tables = document.getElementsByTagName("omni-table");
    for (let i = 0; i < tables.length; i++) {
      this.addFileUploadEventHandler(i);
      let parentCheckbox = tables[i].shadowRoot.querySelector("#taxonomy-table-selectall");
      let actionHeader = tables[i].shadowRoot.querySelectorAll('[data-key="actions"]')[0].children[0];
      if (parentCheckbox)
        parentCheckbox.setAttribute("id",`${i}-taxonomy-table-selectall`);
      if (actionHeader)
        actionHeader.setAttribute("part","th-content pad-left15");  
      this.checkedTaxonomy[i] = [];
      adjustWidth(tables[i]);
    }
  }

  /**
   * Function to add a new taxonomy accordion on click of the 'Add Taxonomy' button
   * @function addCreateTaxonomy
   * @return {void}
   */
  addCreateTaxonomy = () => {
    let currentTaxonomys = [...this.state.createTaxonomys];
    currentTaxonomys.push({
      id: currentTaxonomys.length,
      taxonomyTableData: [],
    });
    this.setState({ createTaxonomys: currentTaxonomys });
  };

  /** The below function is to be called on click of the checkbox in the taxonomy table
   * @function handleCheckboxChange
   * @param {object} taxonomy - clicked taxonomy object
   * @returns {void}
   */
  handleCheckboxChange = (taxonomy) => {
    let currentTaxonomys = [...this.state.createTaxonomys];
    let currentTable = currentTaxonomys[taxonomy.elementId].taxonomyTableData;
    let currentTableRow = currentTaxonomys[taxonomy.elementId].taxonomyTableData[taxonomy._uniqueKey];
    let checkCount = 0;
    this.checkedTaxonomy[taxonomy.elementId] = [];
    currentTableRow.checked = !currentTableRow.checked;
    for (let i = 0; i < currentTable.length; i++) {
      if (currentTable[i].checked) {
        this.checkedTaxonomy[taxonomy.elementId].push(currentTable[i]);
        checkCount++;
      }
    }
    let selectAll = 'none'
    if(checkCount > 0) {
      if(checkCount === currentTable.length){
        selectAll = 'all';
      } else {
        selectAll = 'some';
      }
    }
    this.setState({
      createTaxonomys: currentTaxonomys,
      disableBulkCopy: checkCount !== 1,
      creativeTableCheckAll: selectAll,
    });
  };

  /** The below function is to be called on click of the checkbox in the taxonomy table header
   * @function selectAllTaxonomies
   * @param {object} event - event object
   * @returns {void}
   */
  selectAllTaxonomies = (event) => {
    const checkbox = /** @type {HTMLInputElement} */ (event.target);
    let elementId = Number(checkbox.getAttribute("id").split("-")[0]);
    let currentTaxonomys = [...this.state.createTaxonomys];
    let tableData = currentTaxonomys[elementId].taxonomyTableData;
    for (let i = 0; i < tableData.length; i++) {
      tableData[i].checked = event.target.checked;
    }
    if (event.target.checked) this.checkedTaxonomy[elementId] = [...tableData];
    else this.checkedTaxonomy[elementId] = [];

    this.setState({
      createTaxonomys: currentTaxonomys,
      creativeTableCheckAll: event.target.checked ? 'all' : 'none',
    });
  };

  /**
   * The below function is to be called on click of the 'Create Taxonomy' button after entering the taxonomy value
   * and it will call the create taxonomy API to create the taxonomy
   * @function createSelectedTaxonomy
   * @param {object} element - current accordion element object
   * @param {string} taxonomyValue - taxonomy value
   * @param {string} taxonomySchema - taxonomy schema
   * @param {object} taxonomyFields - taxonomy fields
   * @param {object} selectedTaxonomy - selected taxonomy object
   * @returns {void}
   */
  createSelectedTaxonomy = (element, taxonomyValue, taxonomySchema, taxonomyFields, selectedTaxonomy) => {
    // Validate each field for spaces
    let validationErrors = [];
    const taxonomySchemaFields = selectedTaxonomy?.fields?.filter(f => !f.hidden);
    
    // Parse the values and check each field
    if (taxonomyValue && taxonomySchemaFields) {
      let fieldValues = taxonomyValue.split(/:\||\|/);
      
      for (let i = 0; i < Math.min(fieldValues.length, taxonomySchemaFields.length); i++) {
        const field = taxonomySchemaFields[i];
        if (field?.field_type === 2 && field?.allowed_space === false && fieldValues[i]?.includes(' ')) {
          validationErrors.push(`Space found in field "${field.name}" where spaces are not allowed`);
        }
      }
    }
    
    // Show errors if any
    if (validationErrors.length > 0) {
      AlertMessagesService.showWarningToastMessage(validationErrors[0]);
      return;
    }
    
    // Apply text case transformation using utility function
    let transformedTaxonomyValue = PlacementUtils.transformValueToGivenCase(taxonomyValue, selectedTaxonomy?.taxonomyTextcase);

    // Continue with existing creation logic
    this.setState({ spinnerCount: 1 });
    let payload = {taxonomies: [{
      "taxonomy_schema_id": selectedTaxonomy.id,
      "taxonomy_value": transformedTaxonomyValue,
      "taxonomy_name": selectedTaxonomy.name,
      "created_by": this?.props?.omniProfile?.email,
      "created_at": new Date().toISOString(),
      "taxonomy_schema": taxonomySchema,
      "taxonomy_type_id": selectedTaxonomy?.taxonomy_type
    }]};
    CreateTaxonomyService.createTaxonomy(payload, this.placementSyntheticId)
      .then((response) => { this.getAllTaxonomies("Taxonomy has been created successfully") })
      .catch((err) => { AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.createSelectedTaxonomy(element, taxonomyValue, taxonomySchema, taxonomyFields, selectedTaxonomy), title: 'Unable to create the taxonomy', bodyMsgArr: []}]);})
  };

  /**
   * The below function is to be called to replace the TaxonomyValueID field in the taxonomy schema to {TaxonomyValueID}
   * @function replaceTaxonomyValueIDField
   * @param {object} taxonomy - selected taxonomy object
   * @returns {object} - updated taxonomy object
  */ 
  replaceTaxonomyValueIDField = (taxonomy) => {
    let newTaxonomy = {...taxonomy};
    let schema = newTaxonomy.taxonomySchema.split("|");
    let taxonomySchema = this.state.taxonomyIds[Number(taxonomy.taxonomyId)].schemaFields;
    let stringValues = PlacementDetailsTableService.splitStringIntoArray(taxonomy.taxonomyValue, taxonomySchema,':|');
    let fieldValues = stringValues.nameArr;
    let delimiterValues = stringValues.delimiterArr;
    for(let i=0; i<schema.length; i++) {
      if (this.getFieldObj(10, i, newTaxonomy?.taxonomyId)) {
        fieldValues[i] = "{TaxonomyValueID}";
        break;
      }
    }
    let updatedTaxonomyValue = '';
    for (let i = 0; i < fieldValues.length; i++) {
      //minus 2 because last index values is synthectic not using that in loop
      if (i < fieldValues.length - 2) {
        updatedTaxonomyValue += fieldValues[i] + delimiterValues[i];
      } else {
        updatedTaxonomyValue += fieldValues[i];
      }
    }
    newTaxonomy.taxonomyValue = updatedTaxonomyValue;
    return newTaxonomy;
  }

  /**
   * The below function is to be called on click of the 'Copy' button after selecting the taxonomy to be copied
   * and it will call the create taxonomy API to create the taxonomy
   * @function copyTaxonomy
   * @param {object} taxonomy - selected taxonomy object
   * @returns {void}
   */
  copyTaxonomy = (taxonomy) => {
    this.setState({ spinnerCount: 1 });
    let updatedTaxonomy = this.replaceTaxonomyValueIDField(taxonomy);
    
    // Get taxonomy configuration for text case transformation
    const selectedTaxonomy = Object.values(this.state.allTaxonomyData).find(
        taxonomyData => taxonomyData && Number(taxonomyData.id) === Number(updatedTaxonomy.taxonomyId)
    );
    
    // Apply text case transformation using utility function
    let taxonomyValue = PlacementUtils.transformValueToGivenCase(updatedTaxonomy.taxonomyValue, selectedTaxonomy?.taxonomyTextcase);
    
    let payload = {
      taxonomies: [{
        "taxonomy_schema_id": updatedTaxonomy?.taxonomyId,
        "taxonomy_value": taxonomyValue,
        "taxonomy_name": updatedTaxonomy?.taxonomyName,
        "created_by": this.props?.omniProfile?.email,
        "created_at": new Date().toISOString(),
        "taxonomy_schema": updatedTaxonomy?.taxonomySchema,
        "taxonomy_type_id": updatedTaxonomy?.taxonomyTypeId
      }]
    };
    CreateTaxonomyService.createTaxonomy(payload, this.placementSyntheticId)
      .then((response) => { this.getAllTaxonomies("Taxonomy has been created successfully") })
      .catch((err) => {
        AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.copyTaxonomy(taxonomy), title: 'Unable to create the taxonomy', bodyMsgArr: []}]);
        this.setState({ spinnerCount: 0 });
      });
  };

  /**
   * The below function is to be called on click of the 'Delete' button after selecting the taxonomy to be deleted
   * and it will call the update taxonomy API to delete the taxonomy
   * @function deleteTaxonomy
   * @param {object} taxonomyData - selected taxonomy object
   * @returns {void}
   */
  deleteTaxonomy = (taxonomyData) => {
    this.setState({ spinnerCount: 1 });
    let payload = {
        "taxonomies": [{
          "id": taxonomyData?.taxonomyValueId ? taxonomyData?.taxonomyValueId : taxonomyData?._id,
          "taxonomy_type_id": taxonomyData?.taxonomyTypeId,
          "taxonomy_value_id": taxonomyData?.taxonomyValueId,
          "is_delete": true
        }]
    }
    CreateTaxonomyService.deleteTaxonomy(payload)
      .then(() => {
        this.getAllTaxonomies("Taxonomy has been deleted successfully");
      })
      .catch((err) => {
        AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.deleteTaxonomy(taxonomyData), title: 'Unable to delete the taxonomy', bodyMsgArr: []}]);
        this.setState({ spinnerCount: 0 });
      });
  };

  /**
   * The below function is a event handler attached to the import taxonomy option in the taxonomy table.
   * It will read the selected file and call the create taxonomy API to create the taxonomy
   * @function addFileUploadEventHandler
   * @param {string} tableId - table id
   * @returns {void}
   */
  addFileUploadEventHandler = (tableId) => {
    const fileInput = document.getElementById(`${tableId}-taxonomyInput`);

    fileInput.addEventListener("click", (event) => {
      event.stopImmediatePropagation();
      fileInput.value = null;
    });

    fileInput.addEventListener("change", (event) => {
      event.stopImmediatePropagation();
      const file = fileInput.files[0];
      const reader = new FileReader();
      reader.onload = (event) => {
        const data = event.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        let selectedTaxonomyForImport = {};
        for(let i=0;i<this.state.createTaxonomys.length;i++){
          if(this.state.createTaxonomys[i].id === tableId){
            selectedTaxonomyForImport = this.state.createTaxonomys[i];
            break;
          }
        }
        let selectedTaxonomySchemaId = selectedTaxonomyForImport.taxonomyTableData[0].taxonomyId;
        if(this.props.isCreative){
          this.importCreatives(workbook, selectedTaxonomySchemaId, selectedTaxonomyForImport);
        } else {
          this.importTaxonomies(workbook, selectedTaxonomySchemaId);
        } 
      };
      reader.readAsArrayBuffer(file);
    });
  };

  /**
   * The below function is to be called on click of the import button in the taxonomy table
   * It will read the selected file and call the import taxonomy API to import the taxonomy
   * @param {object} workbook - workbook object
   * @param {string} selectedTaxonomySchemaId - selected taxonomy schema id
   * @returns {void}
  */ 
  importTaxonomies = (workbook, selectedTaxonomySchemaId) => {
    let payload = { taxonomies: [], taxonomy_schema_id: selectedTaxonomySchemaId, userEmail: this.props.omniProfile.email };
    for (let sheetName of workbook.SheetNames) {
      let worksheet = workbook.Sheets[sheetName];
      let sheetRows = XLSX.utils.sheet_to_json(worksheet, { raw: false, blankrows: false });
      for (let i = 0; i < sheetRows.length; i++) {
        if (sheetRows[i]["Taxonomy Type"]) {
          let type = sheetRows[i]["Taxonomy Type"];
          let rowToImport = {
            "ID": sheetRows[i]["ID"],
            "Taxonomy Type": sheetRows[i]["Taxonomy Type"],
          }
          rowToImport[type] = sheetRows[i][type];
          payload.taxonomies.push(rowToImport);
        }
      }
    }
    this.setState({ spinnerCount: 1 });
    CreateTaxonomyService.importTaxonomy(this.placementSyntheticId, payload).then((response) => {
      trackEvent('Taxonomy import success', { access_from: 'Create Taxonomy Page', campaignId: this.props?.params?.campaignId, taxonomy_schema_id: selectedTaxonomySchemaId, count: payload?.taxonomies?.length });
      this.getAllTaxonomies("File has been imported successfully");
    }).catch((err) => {
      AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.addFileUploadEventHandler(tableId), title: 'Unable to import the file', bodyMsgArr: [] }]);
      trackEvent('Taxonomy import failed', { access_from: 'Create Taxonomy Page', campaignId: this.props?.params?.campaignId, taxonomy_schema_id: selectedTaxonomySchemaId, error: err?.response?.data || err });
      this.setState({ spinnerCount: 0 });
    });
  }

  /**
   * The below function is a event handler attached to the Import/Export taxonomy option in the taxonomy table.
   * It will do the export of the taxonomy table data on click of the export option & call the import event handler on click of the import option
   * @function importExportClick
   * @param {object} taxonomyData - selected taxonomy object
   * @param {object} event - event object
   * @returns {void}
   */
  importExportClick = (taxonomyData, event) => {
    const label = event?.detail?.value?.label;
    let selectedTaxonomies =  this.checkedTaxonomy[taxonomyData.id] ? this.checkedTaxonomy[taxonomyData.id] : [];
    let selectedTaxonomiesIds = [];
    for(let i=0;i<selectedTaxonomies.length;i++){
      selectedTaxonomiesIds.push(selectedTaxonomies[i].taxonomyValueId ? selectedTaxonomies[i].taxonomyValueId : selectedTaxonomies[i]._id);
    }
    if (label.includes("Export")) {
      if(selectedTaxonomiesIds.length){
        this.setState({spinnerCount: 1});
        trackEvent('Taxonomy export initiated', { access_from: this.props.isCreative ? 'Create Creative Page' : 'Create Taxonomy Page', campaignId: this.props?.params?.campaignId, count: selectedTaxonomiesIds.length, taxonomyId: taxonomyData?.taxonomy_id });
        this.exportTaxonomy(taxonomyData, selectedTaxonomiesIds);
      } else {
        AlertMessagesService.showWarningToastMessage(`No Taxonomy selected, Please select at least 1 to export.`);
        trackEvent('Taxonomy export attempted with no selection', { access_from: this.props.isCreative ? 'Create Creative Page' : 'Create Taxonomy Page', campaignId: this.props?.params?.campaignId });
      }
    } else {
      document.getElementById(`${taxonomyData.id}-taxonomyInput`).click();
      trackEvent('Taxonomy import file chooser opened', { access_from: this.props.isCreative ? 'Create Creative Page' : 'Create Taxonomy Page', campaignId: this.props?.params?.campaignId });
    }
  };

  /**
   * The below function is to be called on click of the export button in the taxonomy table
   * It will call the export taxonomy API to export the taxonomy
   * @param {object} taxonomyData - selected taxonomy object
   * @param {array} selectedTaxonomiesIds - selected taxonomy ids
  */
  exportTaxonomy = (taxonomyData, selectedTaxonomiesIds) => {
    CreateTaxonomyService.exportTaxonomy(taxonomyData.taxonomy_id, selectedTaxonomiesIds, this.placementSyntheticId).then((response) => {
      // using filesaver the encoded response is decoded and excel file is downloaded with decoded response
      let file = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response}`;
      setTimeout(() => {
        FileSaver.saveAs(file, this.placementId ? `${this.placementId}_Delivered_Taxonomies.xlsx` : `${Utils.getRouteParam("clientid")}_Taxonomies.xlsx`);
        AlertMessagesService.showSuccessToastMessage(`You have successfully exported ${selectedTaxonomiesIds.length} taxonomies`);
        trackEvent('Taxonomy exported', { access_from: this.props.isCreative ? 'Create Creative Page' : 'Create Taxonomy Page', campaignId: this.props?.params?.campaignId, count: selectedTaxonomiesIds.length });
        this.setState({ spinnerCount: 0 });
       });
    }, (error) => {
      AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.exportTaxonomy(taxonomyData, selectedTaxonomiesIds), title: `Unable to export the ${selectedTaxonomiesIds.length} taxonomies`, bodyMsgArr: []}]);
      trackEvent('Taxonomy export failed', { access_from: this.props.isCreative ? 'Create Creative Page' : 'Create Taxonomy Page', campaignId: this.props?.params?.campaignId, error: error?.response?.data || error });
      this.setState({ spinnerCount: 0 });
    });
  }

  /**
   * The below function is to be called on click of the value of taxonomies on each row of the taxonomy table
   * It will open a popup with the taxonomy value & the related options
   * @function taxonomyNameClick
   * @param {object} event - event object
   * @param {number} fieldIndex - index of the taxonomy field
   * @param {object} taxonomyData - selected taxonomy object
   * @returns {void}
   */
  taxonomyNameClick(event, fieldIndex, taxonomyData) {
    event.stopPropagation();
    if (this.openPopupElm) {
      this.openPopupElm.setAttribute("class", "taxonomy-popup");
      this.openPopupElm.style.marginTop = `auto`;
    }
    this.setState({isPopupOpen: true}, ()=>{
      setTimeout(() => {
        let clickElem = document.getElementsByTagName("omni-table")[taxonomyData.elementId].shadowRoot.getElementById(`taxonomy-${taxonomyData.elementId}-${taxonomyData._uniqueKey}-${fieldIndex}`);
        let ele = document.getElementById(`popup-${taxonomyData.elementId}-${taxonomyData._uniqueKey}-${fieldIndex}`);
        let currentTable = document.getElementsByClassName(`taxonomyTable-${taxonomyData.elementId}`)[0];
        let applyBtn = ele.getElementsByClassName("taxonomy-name-apply-button")[0];
        /* This code is positioning a dropdown element based on the position of a click
          element. It sets the "part" attribute of the dropdown element to "taxonomy-popup is-active",
          calculates the position of the dropdown element relative to the click element, and
        */
        if (ele) {
          this.openPopupElm = ele;
          ele.setAttribute("class", "taxonomy-popup is-active");
          const clickElemPos = clickElem.getBoundingClientRect();
          const currentTablePos = currentTable.getBoundingClientRect();
          ele.style.left = clickElemPos.left - 150 + "px";
          ele.style.top = clickElemPos.top - currentTablePos.top + 20 +  "px";
  
          if (applyBtn) {
            applyBtn.setAttribute("class", "taxonomy-name-apply-button");
          }
        }
        event.stopPropagation();
      });
    });
  }

  /**
   * The below function is to be called on click of the cancel button on the taxonomy edit popup
   * It will close the popup
   * @function onCancelEditTaxonomy
   * @param {number} fieldIndex - index of the taxonomy field
   * @param {object} taxonomyData - selected taxonomy object
   * @returns {void}
   */
  onCancelEditTaxonomy = (fieldIndex, taxonomyData) => {
    let ele = document.getElementById(`popup-${taxonomyData.elementId}-${taxonomyData._uniqueKey}-${fieldIndex}`);
    if (ele) {
      ele.setAttribute("class", "taxonomy-popup");
      ele.style.marginTop = `auto`;
    }
    this.setState({isPopupOpen: false});
  };

  /**
   * The below function is to be called on click of the apply button on the taxonomy edit popup
   * It will update the taxonomy value in the state
   * @function updateTaxonomyOnEdit
   * @param {number} fieldIndex - index of the taxonomy field
   * @param {object} taxonomyData - selected taxonomy object
   * @param {array} fieldsArr - array of taxonomy fields value
   * @param {array} delimitersArr - array of taxonomy fields delimiter
   * @returns {string} - updated taxonomy value
  */ 
  updateTaxonomyOnEdit = (fieldIndex, taxonomyData, fieldsArr, delimitersArr) => {
    this.onCancelEditTaxonomy(fieldIndex, taxonomyData);
    this.setState({spinnerCount: 1});
    fieldsArr[fieldIndex] = this.selectedPopupValue;
    let updatedTaxonomyValue = '';
    for (let i = 0; i < fieldsArr.length; i++) {
      if (i < fieldsArr.length - 2) {
        updatedTaxonomyValue += fieldsArr[i] + delimitersArr[i];
      } else {
        updatedTaxonomyValue += fieldsArr[i];
      }
    }
    return updatedTaxonomyValue
  }

   /**
   * Retrieves a field object based on the provided field type and field index.
   * @param {string} fieldType - The type of the field.
   * @param {number} fieldIndex - The index of the field.
   * @returns {object|null} The field object if found, otherwise null.
   */
  getFieldObj = (fieldType, fieldIndex, taxonomyId,synthecticId=null,field) => {
    //if value is synthecticId then return it true , so it will not be editable
    if(synthecticId === field){
      return true
    }
    const taxonomyKeys = Object.keys(this.state.allTaxonomyData)
    // const taxonomyId = this.state.createTaxonomys[0].taxonomy_id?.toString();
    return taxonomyKeys.reduce((acc, key) => {
      const taxonomyData = this.state.allTaxonomyData[key];
      if (taxonomyData?.id?.toString() === taxonomyId) {
        const fields = taxonomyData.fields.filter((field) => !field.hidden);
        const selectedFields = fields?.filter((field, index) => index === fieldIndex && field.field_type === fieldType);
        if (selectedFields?.length === 1) {
          return selectedFields[0];
        }
      }
      return acc;
    }, null);
  }

  /**
   * The below function is to create the taxonomy name with tooltip & edit popup feature
   * @function getEditableTaxonomyName
   * @param {object} taxonomyData - selected taxonomy object
   * @returns {void}
   */
  getEditableTaxonomyName = (taxonomyData, index) => {
    let taxonomySchema = this.state.taxonomyIds[Number(taxonomyData.taxonomyId)]?.schemaFields;
    let fieldArr = taxonomyData.taxonomySchema.split("|");
    let stringValues = PlacementDetailsTableService.splitStringIntoArray(taxonomyData.taxonomyValue, taxonomySchema, ":|");
    let fieldValues = stringValues.nameArr;
    let synthecticId = stringValues?stringValues.syntheticId:null;
    // let isSchemaChange = stringValues.isSchemaChange;
    let delimiterValues = stringValues.delimiterArr;
    //adding synthecticId in field array list to show in table
    if(synthecticId){
      fieldArr.push(synthecticId);
    }
    let isNameAndSchemaFieldMatch = stringValues?.isNameAndSchemaFieldMatch;
    if (isNameAndSchemaFieldMatch && !taxonomyData.isOverride) {
      let row = fieldArr.map((field, fieldIndex) => {
        const isEditDisabled = this.getFieldObj(10, fieldIndex, taxonomyData.taxonomyId, synthecticId, field);
        // fieldArr?.length - 2  use because last index is synthetic id so it will not ad delimeter in end
        if (isEditDisabled) {
          return html`<omni-tooltip-next>
          <span slot="invoker" id="taxonomy-${taxonomyData.elementId}-${taxonomyData._uniqueKey}-${fieldIndex}" part="${isEditDisabled ? 'taxonomy-name-disabled' : 'taxonomy-name'} boldText" class="placement dropdown">
            <span>${fieldValues[fieldIndex]}</span>
          </span>
          <span slot="content">${field}</span>
          </omni-tooltip-next>
          <span part="boldText>${fieldIndex !== fieldArr.length - 2 ? (delimiterValues && delimiterValues[fieldIndex]) : ""}</span>`;
        } else {
          return html`<omni-tooltip-next>
          <span slot="invoker" id="taxonomy-${taxonomyData.elementId}-${taxonomyData._uniqueKey}-${fieldIndex}" part="${isEditDisabled ? 'taxonomy-name-disabled' : 'taxonomy-name'} boldText" class="placement dropdown"
            @click="${(event) => { this.taxonomyNameClick(event, fieldIndex, taxonomyData) }}"><span>${fieldValues[fieldIndex]}</span>
          </span>
          <span slot="content">${field}</span>
          </omni-tooltip-next>
          <span part="boldText">${fieldIndex !== fieldArr?.length - 2 ? (delimiterValues && delimiterValues[fieldIndex]) : ""}</span>`;
        }
      });
      return row;
    } else {
      return html`<omni-tooltip-next>
        <span part="taxonomy-name-disabled boldText" slot="invoker">${taxonomyData.taxonomyValue}</span>
          <div slot="content">Inline edit is disabled because of taxonomy mismatch or a overridden name</div>
        </omni-tooltip-next>`
      }
  };

  /**
   * The below function is to open the copy bulk popup on click of the bulk copy button
   * @function openBulkCopyPopup
   * @param {object} taxonomy - selected table taxonomy object
   * @param {object} event - event object
   * @returns {void}
   */
  openBulkCopyPopup = (taxonomy, event) => {
    event.stopPropagation();
    let ele = document.getElementById(`${taxonomy.id}-bulk-copy-popup`);
    if (ele) {
      ele.setAttribute("class", "taxonomy-popup bulk-copy-popup is-active");
      ele.style.left = event.clientX - 300 + "px";
    }
  }

  /**
   * The below function is to be called on click of the bulk copy button on the taxonomy edit popup
   * Initially it will be hidden and will be shown on click of the bulk copy button
   * @function bulkCopyPopup
   * @param {object} taxonomy - selected table taxonomy object
   * @returns {void}
   */
   bulkCopyPopup = (taxonomy) => {
    return (
      <div part="dropdown" className="taxonomy-popup bulk-copy-popup" id={`${taxonomy.id}-bulk-copy-popup`}>
        <div part="dropdown-menu" className="dropdown-menu1" role="menu">
          <div part="dropdown-content" className="dropdown-content">
            <section part="dropdown-header" className="dropdown-header">
              <p>Copy Taxonomies</p>
            </section>
            <section part="dropdown-section" className="dropdown-item" style={{ paddingLeft: "4px" }}>
              <div part="dropdown-item" style={{ margin: "15px" }}>
                  <div className="full-width bulk-copy-input">
                    <label className="bulk-copy-label"># of {this.state.createType}</label>
                    <input part="input-control" type="text" className="input text taxonomy-popup-input-field" onChange={(event) => this.onBulkCopyInputChange(taxonomy, event)}></input>
                  </div>
              </div>
              <div className="action-btns">
                <button id={`${taxonomy.id}-bulk-copy-cancel-button`} part="taxonomy-name-cancel-button" className="taxonomy-name-cancel-button tertiary" onClick={this.onCancelBulkCopy.bind(this, taxonomy)}>
                  Cancel
                </button>
                <button id={`${taxonomy.id}-bulk-copy-apply-button`} part="taxonomy-name-apply-button" className="taxonomy-name-apply-button" disable="true" onClick={() => {
                  if(this.props.isCreative){
                    this.creativeBulkCopy(taxonomy)
                  } else {
                    this.taxonomyBulkCopy(taxonomy)
                  }
                }}>
                  Apply
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    )
  }

  /**
   * The below function is to be called on change of the bulk copy input field
   * @function onBulkCopyInputChange
   * @param {object} taxonomy - selected table taxonomy object
   * @param {object} event - event object
   * @returns {void}
   */ 
  onBulkCopyInputChange = (taxonomy, event) => {
    let applyBtn = document.getElementById(`${taxonomy.id}-bulk-copy-apply-button`);
    this.bulkCopyCount = event.target.value;
    if (event.target.value && applyBtn) {
        applyBtn.setAttribute("class", "taxonomy-name-apply-button active");
    } else if (!event.target.value && applyBtn) {
        applyBtn.setAttribute("class", "taxonomy-name-apply-button");
    }
  };

  /**
   * The below function is to be called on click of the bulk copy cancel button to close the popup
   * @function onCancelBulkCopy
   * @param {object} taxonomy - selected table taxonomy object
   * @returns {void}
   */ 
  onCancelBulkCopy = (taxonomy) => {
    let ele = document.getElementById(`${taxonomy.id}-bulk-copy-popup`);
    if (ele) {
      ele.setAttribute("class", "taxonomy-popup bulk-copy-popup");
      ele.style.marginTop = `auto`;
    }
  };

  /**
   * The below function is to be called on click of the bulk copy apply button to copy the taxonomy for the given count
   * @function taxonomyBulkCopy
   * @param {object} taxonomy - selected table taxonomy object 
   * @returns {void}
   */ 
  taxonomyBulkCopy = (taxonomy) => {
    this.onCancelBulkCopy(taxonomy);
    let copyTaxonomy = this.checkedTaxonomy[taxonomy.id][0];
    let updatedTaxonomy = this.replaceTaxonomyValueIDField(copyTaxonomy);
    if(copyTaxonomy){
      this.setState({spinnerCount: 1});
      let payload = {taxonomies: []};
      for(let i=0;i<parseInt(this.bulkCopyCount);i++) {
        payload.taxonomies.push({
          "taxonomy_schema_id": updatedTaxonomy?.taxonomyId,
          "taxonomy_value": updatedTaxonomy?.taxonomyValue,
          "taxonomy_name": updatedTaxonomy?.taxonomyName,
          "created_by": this.props?.omniProfile?.email,
          "created_at": new Date().toISOString(),
          "taxonomy_schema": updatedTaxonomy?.taxonomySchema,
          "taxonomy_type_id": updatedTaxonomy?.taxonomyTypeId
        });
      }

      CreateTaxonomyService.createTaxonomy(payload, this.placementSyntheticId).then((response) => {
        this.getAllTaxonomies("Selected Taxonomy has been copied successfully");
      })
      .catch((err) => {
        AlertMessagesService.showMultipleAlerts([{type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.taxonomyBulkCopy(taxonomy), title: 'Unable to copy the selected taxonomy', bodyMsgArr: []}]);
        this.setState({spinnerCount: 0});
      });
    }
  };

  /**
   * The below code is defining a function called `getCheckboxWithNameElement` in JavaScript. This function takes
   * a parameter called `value` and generates HTML code for a table cell containing a checkbox.
   * @function getCheckboxWithNameElement
   * @param {object} value - taxonomy object
   * @returns {void}
   */
   getCheckboxWithNameElement = (value, index) => {
    return html` <style>
        :host::part(table-body-cell-taxonomy-checkboxes) {
          padding-left: 44px;
          display: flex;
          align-items: center;
          border: 0px;
          height: 60px;
        }
        :host::part(select-taxonomy-checkbox) {
          width: 18px;
          height: 18px;
          margin-top: 2px;
          background-color: #3b3e3f;
        }
      </style>
      <div part="table-body-cell-taxonomy-checkboxes" class="is-main">
        <omni-checkbox
          id="input-${value && value._uniqueKey}"
          style=" --checkbox-height-width: 18px; --checkbox-border-color: #837f7f;"
          ?checked=${value.checked}
          @change=${this.handleCheckboxChange.bind(this, value)}
          @click=${(event) => {event.stopPropagation()}}
        ></omni-checkbox>
        <span part="td-content wrapText" class="taxonomyNameCol" style="width: ${Utils.calculatetaxonomyWidth(value.placement_taxonomy,true)}">${this.getEditableTaxonomyName(value, index)}</span>
      </div>`;
  };

  // The below code is defining the columns of the taxonomy table.
  getColumns = () => {
    let rows = [{
      label: html`
      <omni-checkbox 
        part="selectall-taxonomy-checkbox" 
        style=" --checkbox-height-width: 18px; --checkbox-border-color: #837f7f;"
        id="taxonomy-table-selectall" 
        @change=${this.selectAllTaxonomies}  
        @click=${(event) => {event.stopPropagation()}}
        ?checked=${this.state.creativeTableCheckAll === 'all'}
        ?indeterminate=${this.state.creativeTableCheckAll === "some"}>
      </omni-checkbox>
      <span part="taxonomy-column-header-name">${this.props.isCreative ? 'Creative' : 'Taxonomy'}</span>`,
      key: "taxonomyValue",
      isSortable: false,
      passthrough: true,
      isMain: true,
      template: (value, index) => {
        return html`
          <style>
            :host::part(taxonomy-name-disabled) {
              cursor: not-allowed;
            }

            :host::part(boldText) {
              color: #3B3E3F;
              font-weight: 600;
            }

            :host::part(taxonomy-name):hover {
              color: rgb(0 161 210);
              cursor: pointer;
            }

            :host::part(taxonomyName) {
              display: inline;
            }

            :host::part(table-body-cell) {
              position: relative;
            }

            :host::part(table-body) {
              transform-style: initial;
            }

            :host::part(table-body-row) {
              transform: initial;
            }

            :host::part(table-header-actions) {
              text-align: center;
            }
            :host::part(wrapText) {
              display: flex;
              flex-wrap: wrap;
              white-space: normal;
              line-height: 20px;
              max-height: 40px;
              overflow: hidden;
              word-break: break-all;
              margin-left: 25px;
            }
            :host::part(selectall-taxonomy-checkbox) {
              margin-left: 14px;
            }
            :host::part(taxonomy-column-header-name) {
              margin-left: 20px;
            }
          </style>
          ${this.getCheckboxWithNameElement(value, index)}`;
      },
    },
    {
      label: "ACTIONS",
      key: "actions",
      passthrough: true,
      template: (value) => {
        if(value.syncStatus === 'In Platform'){
          return html`
          <style>
            :host::part(pad-left15) {
              padding-left: 15px;
            }
          </style>
          <td part="table-body-cell">
            <span part="td-content">
              <div style="display: flex;justify-content: right;" class="table-row-actions">
                <omni-tooltip-next>
                  <button slot="invoker" aria-haspopup="true" class="icon" @click="${() => this.copyTaxonomy(value)}">
                    <omni-icon class="is-size-4 cursor" part="action-button-icon" icon-id="omni:interactive:copy"></omni-icon>
                  </button>
                  <div slot="content">Copy</div>
                </omni-tooltip-next>
              </div>
            </span>
          </td>`;
        } else {
          return html`
          <style>
            :host::part(pad-left15) {
              padding-left: 15px;
            }
          </style>
          <td part="table-body-cell">
            <span part="td-content">
              <div class="table-row-actions">
                <omni-tooltip-next>
                  <button slot="invoker" aria-haspopup="true" class="icon" @click="${() => {
                    this.copyTaxonomy(value)
                  }}">
                    <omni-icon class="is-size-4 cursor" part="action-button-icon" icon-id="omni:interactive:copy"></omni-icon>
                  </button>
                  <div slot="content">Copy</div>
                </omni-tooltip-next>
                <omni-tooltip-next>
                  <button slot="invoker" aria-haspopup="true" class="icon" @click="${() => {
                    this.deleteTaxonomy(value)
                  }}">
                    <omni-icon class="is-size-4 cursor" part="action-button-icon" icon-id="omni:interactive:delete"></omni-icon>
                  </button>
                  <div slot="content">Delete</div>
                </omni-tooltip-next>
              </div>
            </span>
          </td>`;
        }
      },
    }]

    // If the screen is not in Creative mode, add the "DELIVERED SYNC STATUS" column
    // to the beginning of the right columns
    if(!this.props.isCreative){
      rows = rows.toSpliced(1, 0, {
        label: "DELIVERED SYNC STATUS",
        key: "syncStatus",
        passthrough: true,
        template: (value) => {
          if(value.syncStatus === 'In Platform'){
            return html`
            <style>
              :host::part(greenText) {
                color: #2cc4ad;
              }
              :host::part(table-header-cell){
                max-width: 100% !important;
              }
            </style>
            <td part="table-body-cell">
              <span part="td-content greenText">${value.syncStatus}</span>
            </td>`;
          } else {
            return html`
            <style>
              :host::part(table-header-cell){
                max-width: 100% !important;
              }
            </style>
            <td part="table-body-cell">
              <span part="td-content">${value.syncStatus}</span>
            </td>`;
          }
        },
      });
    }
    return rows;
  }

  /**CREATIVE SCREEN RELATED FUNCTIONS*/

  /**
   * The below function is a GET call to get all creatives for a given client
   * @param {string} successMsg - success message to be displayed on success of the API call
   * @returns {void}
  */
  getAllCreatives = (successMsg,pageLoad = false) => {
    let creativeData = this.props?.creativeData;
    if (creativeData?.length && pageLoad) {
      this.setCreativeTableData(creativeData, successMsg);
    }else{
      this.callCreativeApi(successMsg);
    }
  }

  callCreativeApi = (successMsg,totalCreativeData = [], hasNextCall = null) => {
    this.setState({ spinnerCount: 1 });
    let parentId = this.props.state?.campaignObj?.parent_id;
    CreateCreativeService.getCreatives(null, this.props?.params?.campaignId,hasNextCall, parentId).then((response) => {
      // accumulating data for pagination
      totalCreativeData.push(...response?.data?.Items);
      let hasNext = response?.data?.paging?.next;
      if(!hasNext){
          this.setCreativeTableData(totalCreativeData,successMsg);
      }else {
          this.callCreativeApi(successMsg,totalCreativeData,hasNext);
      }
      
    }).catch((err) => {
      AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.getAllCreatives(successMsg), title: 'Unable to get creatives', bodyMsgArr: [] }]);
    }).finally(() => {
      this.setState({ spinnerCount: 0 });
    });
  }

  setCreativeTableData = (data, successMsg) => {
    let taxonomyMap = {};
    for (let i = 0; i < data.length; i++) {

        // check the login/update time and set highlight true for creatives
        let highlight = false;
        const loginTime = new Date(new Date(CookieService.getCookie("LoginTime")).toUTCString());
        const createTime = new Date(data[i]?.created_at + 'Z');
        const updateTime = new Date(data[i]?.updated_at + 'Z');
        if ((loginTime < createTime && data[i]?.created_by === this.props.omniProfile?.email) || (loginTime < updateTime && data[i]?.updated_by === this.props.omniProfile?.email)) {
          highlight = true;
        }

        let taxonomyObj = {
          rowIndex: i,
          _id: data[i].creative_id,
          taxonomyName: data[i].creative_type,
          taxonomyValue: data[i].creative_name,
          taxonomySchema: data[i].taxonomy_schema,
          taxonomyId: data[i].taxonomy_schema_id,
          supplierCode: data[i].supplier_code,
          dimensions: data[i].dimensions,
          dimensions_position: data[i].dimensions_position,
          site: data[i].supplier,
          checked: false,
          isOverride: data[i].is_override,
          isCreative: true,
          highlight: highlight
        };
        taxonomyObj = { ...data[i], ...taxonomyObj };
        let creativeType = this.mapCreativeTypeToTaxonomy(data[i].creative_type);
        // Grouping based on taxonomy
        if (!taxonomyMap[creativeType]) {
          taxonomyMap[creativeType] = [];
          taxonomyMap[creativeType].push(taxonomyObj);
        } else {
          taxonomyMap[creativeType].push(taxonomyObj);
        }
    }

    // set final map for table structure
    this.createTableStructure(taxonomyMap);
    if (successMsg) {
      AlertMessagesService.showSuccessToastMessage(successMsg);
    }
  }
  /**
   * This function maps creative types to taxonomy categories.
   * @param {string} creativeType - The type of creative to map.
   * @returns {string|null} - The mapped taxonomy category or null if not found.
   */
  mapCreativeTypeToTaxonomy = (creativeType) => {
    for(let key in creativeMap) {
      if(creativeMap[key].includes(creativeType)) {
        return creativeMap[key][0];
      }
    }
    return null;
  }

  /**
  * The below function is to be called on click of the 'Create Creative' button after entering the creative value
  * and it will call the create creative API to create the creative
  * @function createSelectedCreative
  * @param {object} element - current accordion element object
  * @param {string} taxonomyValue - taxonomy value
  * @param {string} taxonomySchema - taxonomy schema
  * @param {object} selectedTaxonomy - selected taxonomy object
  * @param {object} formdata - form data object
  * @returns {void}
  */
  createSelectedCreative = (element, taxonomyValue, taxonomySchema, selectedTaxonomy, formdata, isOverride, taxonomyObjArray) => {
    // Validate taxonomyValue for spaces
    const taxonomySchemaFields = selectedTaxonomy?.fields?.filter(f => !f.hidden);
    
    if (taxonomyValue && taxonomySchemaFields) {
      let fieldValues = taxonomyValue.split(/:\||\|/);
      
      for (let i = 0; i < Math.min(fieldValues.length, taxonomySchemaFields.length); i++) {
        const field = taxonomySchemaFields[i];
        if (field?.field_type === 2 && field?.allowed_space === false && fieldValues[i]?.includes(' ')) {
          AlertMessagesService.showWarningToastMessage(`Space found in field "${field.name}" where spaces are not allowed`);
          return;
        }
      }
    }
    
    // Apply text case transformation using utility function
    let transformedTaxonomyValue = PlacementUtils.transformValueToGivenCase(taxonomyValue, selectedTaxonomy?.taxonomyTextcase);
    
    // Continue with existing creative creation logic
    this.setState({ spinnerCount: 1 });
    let payload = [{
      "creative_name": transformedTaxonomyValue,
      "creative_type": formdata.creativeTemplate.split(" ").join(""),
      "creative_display_name": transformedTaxonomyValue,
      "taxonomy_schema": taxonomySchema,
      "taxonomy_schema_name": selectedTaxonomy.name,
      "supplier": formdata['Site'],
      "supplier_code": formdata['Supplier Code'],
      "taxonomy_schema_id": selectedTaxonomy?.id,
      "is_override": isOverride,
      "campaign_id": this.props.params.campaignId,
      "taxonomy": null,
      "taxonomy_client_id": selectedTaxonomy.clientid,
      "dimensions": formdata['Dimensions'],
      "dimensions_position": formdata['Dimension/Positions']
    }];

    if (!isOverride) {
      taxonomyObjArray = PlacementUtils.insertTaxonomyValueIdsIntoTaxonomy(selectedTaxonomy?.fields, taxonomyObjArray, false)?.taxonomyObjArray;
      payload[0].taxonomy = taxonomyObjArray;
    }

    CreateCreativeService.createCreative(payload)
      .then((response) => { this.getAllCreatives("Creative has been created successfully") })
      .catch((err) => { AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.createSelectedCreative(element, taxonomyValue, taxonomySchema, selectedTaxonomy, formdata, isOverride, taxonomyObjArray), title: 'Unable to create the creative', bodyMsgArr: [] }]); })
  }
  
  /**
   * The below function is to be called on click of the bulk copy button on the creative edit popup
   * It will call the create creative API to copy the creative
   * @function creativeBulkCopy
   * @param {object} creative - selected creative object
   * @returns {void}
  */ 
  creativeBulkCopy = (creative) => {
    this.onCancelBulkCopy(creative);
    let copyCreative = this.checkedTaxonomy[creative.id][0];
    let updatedCreative = this.replaceTaxonomyValueIDField(copyCreative);
    if(copyCreative){
      this.setState({spinnerCount: 1});
      
      // Get taxonomy configuration for text case transformation
      const selectedTaxonomy = Object.values(this.state.allTaxonomyData).find(
          taxonomy => taxonomy && taxonomy.id === updatedCreative.taxonomyId
      );
        
      let payload = [];
      for(let i=0;i<parseInt(this.bulkCopyCount);i++) {
        let creativeName = updatedCreative.taxonomyValue.split(":|")[0];
        
        // Apply text case transformation using utility function
        creativeName = PlacementUtils.transformValueToGivenCase(creativeName, selectedTaxonomy?.taxonomyTextcase);
          
        payload.push({
          "creative_name": creativeName,
          "creative_type": updatedCreative.taxonomyName,
          "creative_display_name": creativeName,
          "taxonomy_schema": updatedCreative.taxonomySchema,
          "taxonomy_schema_name": updatedCreative.taxonomy_schema_name,
          "supplier": updatedCreative.supplier,
          "supplier_code": updatedCreative.supplier_code,
          "taxonomy_schema_id": updatedCreative.taxonomyId,
          "is_override": updatedCreative.isOverride,
          "campaign_id": this.props.params.campaignId,
          "taxonomy": null,
          "taxonomy_client_id": selectedTaxonomy.clientid,
          "dimensions": updatedCreative.dimensions,
          "dimensions_position": updatedCreative.dimensions_position
        });
      }
      CreateCreativeService.createCreative(payload)
      .then((response) => { this.getAllCreatives("Creative has been bulk copied successfully") })
      .catch((err) => { AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.creativeBulkCopy(creative), title: 'Unable to bulk copy the selected creative', bodyMsgArr: []}]);})
      .finally(() => this.setState({spinnerCount: 0}));
    }
  };

  /**
   * The below function is to be called on click of the import button on the action menu
   * It will call the import creative API to import the creatives
   * @param {object} workbook - workbook object
   * @param {string} taxonomyId - taxonomy id
   * @param {object} tableData - table data object
   * @returns {void}
  */ 
  importCreatives = (workbook, taxonomyId, tableData) => {
    let createPayload = [];
    let editPayload = [];
    let taxonomyNameArr = [];
    let taxonomySchema = '';
    let selectedTaxonomy = {};
    let taxonomyClientId ='';
    let taxonomySchemaId= '';
    const creativeType = tableData.taxonomyTableData[0]?.creative_type;
    const taxonomySchemaName = tableData.taxonomyTableData[0]?.taxonomy_schema_name;
    
    // create the schema for the import
    for (let key in this.state.allTaxonomyData) {
      let taxonomyData = this.state.allTaxonomyData[key];
      if (taxonomyData?.id === Number(taxonomyId)) {
        let schema = CreateTaxonomyService.generateTaxonomySchema(taxonomyData);
        taxonomyClientId = taxonomyData.clientid;
        taxonomySchemaId = taxonomyData.id;
        taxonomyNameArr = schema.taxonomyNameDelimiterList;
        taxonomySchema = schema.taxonomySchema;
        selectedTaxonomy = taxonomyData;
        break;
      }
    }
    // Get the excel data in JSON format
    let worksheet = workbook.Sheets["Creatives"];
    let sheetRows = XLSX.utils.sheet_to_json(worksheet, { header: 1});
    sheetRows = sheetRows.filter(arr => arr?.some(Boolean));
    let creativeColumns = sheetRows[0];
    let creativeIdIndex = creativeColumns.indexOf("creative_id");
    let isOverrideIndex = creativeColumns.indexOf("Override Creative");
    let taxonomyValueIndex=creativeColumns.indexOf('TaxonomyValueID');

    let creativeNameIndex = creativeIdIndex - 1;
    for (let i = 1; i < sheetRows.length; i++) {
      let creativeValues = sheetRows[i];
      if (creativeValues[0]) {
        let taxonomyName = creativeValues[creativeNameIndex];
        if (!creativeValues[creativeIdIndex] && taxonomyValueIndex!=-1 && creativeValues[taxonomyValueIndex]){
          taxonomyName =taxonomyName.replace(creativeValues[taxonomyValueIndex],'{TaxonomyValueID}')
          creativeValues[taxonomyValueIndex]='{TaxonomyValueID}'
        }
        // Apply text case transformation using utility function
        taxonomyName = PlacementUtils.transformValueToGivenCase(taxonomyName, selectedTaxonomy?.taxonomyTextcase);
 
      const obj = Object.fromEntries(
        creativeColumns.map((key, index) => [key, creativeValues[index]])
      );
      let {taxonomySelectedValueJson}= PlacementUtils.createNames(obj,selectedTaxonomy,true);
      taxonomySelectedValueJson = taxonomySelectedValueJson.map((item) => {
            delete item['field_name'];
            delete item['name'];
            delete item['hidden'];
            return item;
        });
        // If there is no creative ID, then create a Payload for creation
        if (!creativeValues[creativeIdIndex]) {
          let createObj = {
            "creative_name": taxonomyName,
            "creative_display_name": taxonomyName,
            "creative_type": creativeType,
            "taxonomy_schema": taxonomySchema,
            "taxonomy_schema_name": taxonomySchemaName,
            "taxonomy_client_id":taxonomyClientId,
            "taxonomy_schema_id":taxonomySchemaId,
            // "supplier": tableData.taxonomyTableData[0]?.supplier, // Disabled for now as we don't have these column in export file, so the value will be null for import.
            // "supplier_code": tableData.taxonomyTableData[0]?.supplier_code,
            "is_override": creativeValues?.[isOverrideIndex]?.toLowerCase() === 'no' ? false : true,
            "campaign_id": this.props.params.campaignId,
            "taxonomy":creativeValues?.[isOverrideIndex]?.toLowerCase() === 'no' ? taxonomySelectedValueJson : null
          }
          createPayload.push(createObj);
          // If there is a creative ID, then create a Payload for updation
        } else if (creativeValues[creativeIdIndex]) {
          let updatedCreative = tableData.taxonomyTableData.find(creative => creative.creative_id === creativeValues[creativeIdIndex]);
          let editObj = {
            "taxonomy_client_id":taxonomyClientId,
            "taxonomy_schema_id":taxonomySchemaId,
            "creative_id": creativeValues[creativeIdIndex],
            "creative_name": taxonomyName + ":|" + creativeValues[creativeIdIndex],
            "creative_display_name": taxonomyName,
            "is_override": creativeValues?.[isOverrideIndex]?.toLowerCase() === 'no' ? false : true,
            "taxonomy":creativeValues?.[isOverrideIndex]?.toLowerCase() === 'no' ? taxonomySelectedValueJson : null,
            "dimensions": updatedCreative?.dimensions,
            "dimensions_position": updatedCreative?.dimensions_position
          }
          editPayload.push(editObj);
        }
      }
    }
    this.setState({ spinnerCount: 1 });
    let promiseArr = [];
    if (createPayload.length) {
      promiseArr.push(CreateCreativeService.createCreative(createPayload));
    }
    if (editPayload.length) {
      promiseArr.push(CreateCreativeService.updateCreative(editPayload))
    }
    // call both creation & updation call
    Promise.all(promiseArr).then(() => { 
      trackEvent('Creatives import success', { access_from: 'Create Creative Page', campaignId: this.props?.params?.campaignId, created: createPayload.length, updated: editPayload.length, taxonomyId });
      this.getAllCreatives("Creative(s) has been imported successfully") 
    }).catch((err) => {
      this.setState({ spinnerCount: 0 }); 
      AlertMessagesService.showMultipleAlerts([{ type: 'danger', retryBtnText: 'Retry', retryBtnEvent: () => this.importCreatives(workbook, taxonomyId, tableData), title: 'Unable to import the creative(s)', bodyMsgArr: [] }]); 
      trackEvent('Creatives import failed', { access_from: 'Create Creative Page', campaignId: this.props?.params?.campaignId, created: createPayload.length, updated: editPayload.length, taxonomyId, error: err?.response?.data || err });
    })
  }

  render() {
    return (
      <>
        <LoaderComponent spinnerCount={this.state.spinnerCount} displayWholePage={true} />
        {Object.keys(this.state?.allTaxonomyData)?.length > 0 &&
          <div>
            <div className="create-taxonomy-title-container">
              <h2>Create {this.state.createType}</h2>
              <span>Create new {this.state.createType} by choosing a template and selecting all available taxonomy field options</span>
            </div>
            <div className="create-taxonomy-container1">
              {this.state.createTaxonomys.map((element) => (
                <div key={`accordion-${element.taxonomy_id}`}>
                  <input type="file" id={`${element.id}-taxonomyInput`} accept=".xlsx, .xls" hidden />
                  <div className="taxonomy-accordion">
                    <CreateTaxonomyAccordionContentComponent
                      params={this.props.params}
                      state={this.props.state}
                      isCreative={this.props.isCreative}
                      allTaxonomyData={this.state.allTaxonomyData}
                      createSelectedTaxonomy={this.createSelectedTaxonomy.bind(this, element)}
                      createSelectedCreative={this.createSelectedCreative.bind(this, element)}
                      selectedDD={this.state.taxonomyIds[Number(element.taxonomy_id)]?.type}
                      accordionData={element}
                      setSpinnerCount={this.props.setSpinnerCount}
                    ></CreateTaxonomyAccordionContentComponent>

                    {!!element.taxonomyTableData?.length > 0 && (
                      <div className={`taxonomyTable-${element.id} posrel`}>
                        {this.props.isCreative ?
                          <CreativeAgGridComponent
                            tableData={element} 
                            allCreativeFunc={this.getAllCreatives}
                            fileUploadListner={this.addFileUploadEventHandler}
                            allTaxonomyData={this.state.allTaxonomyData}
                            taxonomyIds={this.state.taxonomyIds}
                            checkEditable={this.getFieldObj} 
                            setState={this.setState.bind(this)}
                            setSpinnerCount={this.props.setSpinnerCount}
                            campaignId={this.props?.params?.campaignId}
                            campaignObj={this.props.state?.campaignObj}
                            omniProfile={this.props?.omniProfile}
                            systemParametersData={this.props?.systemParametersData}
                            versionOneApi={this.props?.versionOneApi}
                          ></CreativeAgGridComponent>
                          :
                          <>
                            <OmniTileComponent heading="" key={element.id}>
                              <OmniToolbarComponent slot="header" className="margin5" key={`toolbar-${element.id}`}>
                                <div slot="start">
                                  <span>{this.state.createType} Strings</span>
                                </div>
                                <div slot="end" className="custom-dropdown-menu">
                                  <OmniIconMenu
                                    options={[`Import ${this.state?.createType}`, `Export ${this.state?.createType}`]}
                                    key={`icon-${element.id}`}
                                    iconId="omni:interactive:importExport"
                                    iconClass="is-size-4 header-icon"
                                    tooltip="Import/Export"
                                    onDropdownChange={(event) => this.importExportClick(element, event)}
                                  ></OmniIconMenu>
                                </div>
                                <div slot="end" className="custom-dropdown-menu">
                                  <OmniTooltipNextComponent key={element.id}>
                                    <button slot="invoker" aria-haspopup="true" disabled={this.state.disableBulkCopy} className="button is-text is-shadowless" onClick={(event) => this.openBulkCopyPopup(element, event)}>
                                      <OmniIconComponent className="is-size-4 header-icon" icon-id="omni:interactive:copy"></OmniIconComponent>
                                    </button>
                                    <div slot="content">Bulk Copy</div>
                                  </OmniTooltipNextComponent>
                                  {this.bulkCopyPopup(element)}
                                </div>
                              </OmniToolbarComponent>
                            </OmniTileComponent>
                            <OmniTableComponent id="creative-table" data={element.taxonomyTableData} columns={this.getColumns()} key={`taxonomyTable-${element.id}`} keyFn={(row) => row && row._uniqueKey}></OmniTableComponent>
                          </>
                        }
                      </div>
                    )}
                  </div>
                </div>
              ))}
              <button className="secondary" onClick={() => { this.addCreateTaxonomy() }}>
                <omni-icon className="is-size-4" icon-id="omni:interactive:add"></omni-icon>
                <span>Add {this.state.createType}</span>
              </button>
            </div>
          </div>
        }
      </>
    );
  }
}
